<!-- <div class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5)">
  <div class="modal-dialog modal-dialog-centered" [ngClass]="sizeClass">
    <div class="modal-content">
      <div class="modal-header border-0 text-center flex-column">
        <div *ngIf="config.icon" class="mb-3">
          <i [class]="config.icon" [style.color]="config.iconColor"></i>
        </div>
        <h5 class="modal-title">{{ config.title }}</h5>
      </div>
      <div class="modal-body text-center">
        <p>{{ config.message }}</p>
      </div>
      <div class="modal-footer border-0 flex-column flex-sm-row w-100">
        <ng-container *ngIf="config.layout === 'side-by-side'; else stackedButtons">
          <button class="btn btn-outline-secondary w-100 me-sm-2" (click)="close(false)">
            {{ config.cancelText || 'Cancel' }}
          </button>
          <button class="btn" [ngClass]="config.confirmBtnClass" (click)="close(true)">
            {{ config.confirmText || 'OK' }}
          </button>
        </ng-container>
        <ng-template #stackedButtons>
          <button class="btn w-100 mb-2" [ngClass]="config.confirmBtnClass" (click)="close(true)">
            {{ config.confirmText || 'OK' }}
          </button>
          <button class="btn btn-outline-secondary w-100" (click)="close(false)">
            {{ config.cancelText || 'Cancel' }}
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</div> -->

<div class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5)">
  <div class="modal-dialog modal-dialog-centered" [ngClass]="isMobile ? 'modal-sm' : 'modal-md'">
    <div class="modal-content">
      <div class="modal-body text-center">
        <div class="icon mb-3">
          <i class="bi bi-exclamation-triangle-fill text-danger fs-1"></i>
        </div>
        <h5 class="fw-bold">{{ config.title || 'Confirmation' }}</h5>
        <p class="text-muted">{{ config.message }}</p>
      </div>

      <!-- Footer -->
      <div class="modal-footer border-0 w-100 pt-0" [ngClass]="isMobile ? 'flex-column' : 'align-item-end'">

        <!-- Desktop: Side-by-side -->
        <ng-container *ngIf="!isMobile">
          <button class="btn btn-outline-secondary px-4" (click)="close(false)">
            {{ config.cancelText || 'No' }}
          </button>
          <button class="btn btn-danger px-4" (click)="close(true)">
            {{ config.confirmText || 'Yes' }}
          </button>
        </ng-container>

        <!-- Mobile: Stacked -->
        <ng-container *ngIf="isMobile">
          <button class="btn btn-danger w-100 mb-2" (click)="close(true)">
            {{ config.confirmText || 'Yes' }}
          </button>
          <button class="btn btn-outline-secondary w-100" (click)="close(false)">
            {{ config.cancelText || 'No' }}
          </button>
        </ng-container>

      </div>
    </div>
  </div>
</div>